import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { IconNavSharedComponent } from './icon.nav.component';

import { FaIconSharedModule } from './../../atoms/fa.icon/fa.icon.module';

@NgModule({
    declarations: [
        IconNavSharedComponent
    ],
    imports: [
        CommonModule,
        FaIconSharedModule,
        RouterModule.forChild([])
    ],
    exports: [
        IconNavSharedComponent
    ]
})

export class IconNavSharedModule {}
